import React, { Fragment, useContext, useEffect, useState } from "react";
// Provider
import { AppContext } from "../../../components/AppProvider";

// Utils
import { _CHECK, _O } from "../../../modules/utils";

// UI
//import { IC, Doctor } from "../../../resources/Assets";
import { Container, openLayerFn } from "../../Layout";

import { AlertLayer, ConfirmLayer } from "../../../components/UI/Dialog";
import { PersonalInfo } from "./MyInfo.Layers";

import { sha256 } from "js-sha256";
import { PostApi1915 } from "../../../modules/network/padoPost";

// import _T_PRESCRIPTION from "../../resources/images/sub/prescription_img.jpg";

export default props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const [inputs, setInputs] = useState({
    oldPassword: "",
    newPassword1: "",
    newPassword2: "",
  });

  const { oldPassword, newPassword1, newPassword2 } = inputs;

  useEffect(() => {});

  const handleChanged = e => {
    const { name } = e.target;

    setInputs({
      ...inputs,
      [name]: e.target.value,
    });
  };

  const request1915 = (oldPassword, newPassword) => {
    PostApi1915(
      userinfo,
      cfg,
      phonecfg,
      userinfo.userId,
      oldPassword,
      newPassword
    )
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          console.log(res);
          switch (res.result) {
            case 0:
              handleAlert("확인", "비밀번호가 변경되었습니다.");
              setInputs({
                oldPassword: "",
                newPassword1: "",
                newPassword2: "",
              });
              break;
            case 1:
              handleAlert("확인", "비밀번호 변경에 실패했습니다.");
              break;
            case 2:
              handleAlert("확인", "현재비밀번호가 맞지 않습나다.");
              break;
            case 3:
              handleAlert("확인", "비밀번호 변경에 실패했습니다.");
              break;
            default:
              handleAlert("확인", "비밀번호 변경에 실패했습니다.");
              break;
          }

          // 저장 후 팝업 닫고 하단 페이지  새로고침
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const saveNewPassword = () => {
    console.log("saveNewpassword", oldPassword, newPassword1, newPassword2);
    if (oldPassword.trim().length === 0) {
      handleAlert("확인", "현재비밀번호를 입력해 주세요.");
    } else if (newPassword1 !== newPassword2) {
      handleAlert("확인", "새 비밀번호를 확인해 주세요.");
    } else if (!_CHECK.PwdCheck(newPassword1))
      handleAlert(
        "확인",
        "비밀번호는 영어소문자, 숫자 5자 이상으로 구성되어야 합니다."
      );
    else {
      let newPass = sha256(userinfo.userId + "eocs" + newPassword1);
      let oldPass = sha256(userinfo.userId + "eocs" + oldPassword);
      request1915(oldPass, newPass);
    }
  };

  const getBottom = ({ onChange }) => {
    return (
      <div className="fix-area">
        <div>
          <div className="under-fix-btnarea">
            <a
              href={void 0}
              className="btn-full-confim open-confirm-layer"
              onClick={saveNewPassword}>
              <i className="mod"></i>{" "}
              {userinfo.signUpChannel === "000" ? "수정" : ""}
            </a>
          </div>
        </div>
      </div>
    );
  };

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleAlert = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const handleConfirm = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".confirm-layer"));
  };
  const handleConfirmConfirmCB = () => {};
  const handleConfirmCancelCB = () => {
    _O.OpenMenu("/");
  };

  const handleAlertCB = () => {
    console.log("handleAlertCB");
  };

  return (
    <Fragment>
      <Container
        Title={"내 정보 수정"}
        dark={"dark"}
        goToUrl={"/mp"}
        bottom={getBottom({ onChange: null })}>
        <div className="contents">
          <div className="sub-contents">
            <PersonalInfo modify={true} handleChange={handleChanged} />
          </div>
        </div>
      </Container>
      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleAlertCB}
      />

      <ConfirmLayer
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleConfirmCancelCB}
        handleConfirmCB={handleConfirmConfirmCB}
      />
    </Fragment>
  );
};
